<template>
  <div>
    <p class="white--text text-subtitle-1">{{ title }}</p>
    <div
      class="inner"
      :list="value"
      :id="name"
      :group="`${year}-notes`"
      @start="startDrag()"
      @end="endDrag()"
    >
      <row-card
        class="list-group-item"
        v-for="element in value"
        :key="`${titlelc}-${element.id}`"
        :card="element"
        :all="all"
        :color="color"
        :data-id="element.id"
        @editNote="editNote"
        @showNote="showNote"
        @removeNote="removeNote"
      >
      </row-card>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RowCard from "@/views/user/exercises/timeline/RowCard";
// import draggable from "vuedraggable";
export default {
  name: "RowCol",
  data() {
    return {
      dragging: false,
    };
  },
  props: {
    value: Array,
    title: String,
    all: Array,
    name: String,
    year: String,
    color: String,
  },
  watch: {
    value: {
      handler: function(val) {
        // console.log("cols value changed", val);
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  computed: {
    titlelc() {
      return this.title.toLowerCase();
    },
  },
  components: {
    RowCard,
    // draggable,
  },
  methods: {
    editNote($event) {
      this.$emit("editNote", $event);
    },
    showNote($event) {
      this.$emit("showNote", $event);
    },
    removeNote($event) {
      this.$emit("removeNote", $event);
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.value.find((x) => x.id == doc.dataset.id);
        if (item) {
          let indexOfItem = this.value.indexOf(item);
          item.index = count;
          vm.$set(vm.value, indexOfItem, item);
        }
        count++;
      });
      this.dragging = false;
      this.$emit("autosave");
    },
  },
};
</script>
